import { HelpLang } from './types';

/**
 * The language help mode shows. English only for now.
 *
 * To turn on Bangla later: return the user's choice here (a profile setting or a toggle in the
 * help bar), add the label texts in uiText.ts, and add translated files under help/i18n/bn/
 * (see help/i18n/README.md). Nothing else has to change: every text falls back to English when
 * a translation is missing.
 */
export function currentHelpLang(): HelpLang {
    return 'en';
}
